<template>
    <!--<Cascader clearable :data="region" v-model="value" :change-on-select="true" @on-change="onChange"/>-->
    <div class="d-flex justify-start">
        <div class="d-flex-item">
            <Select clearable class="width-all" v-model="value[0]" @on-select="onProvs">
                <Option v-for="(item, index) in provs" :value="item.code" :key="index">{{ item.name }}</Option>
            </Select>
        </div>
        <div class="d-flex-item ml-xs">
            <Select clearable class="width-all" v-model="value[1]" @on-select="onCitys">
                <Option v-for="(item, index) in citys" :value="item.code" :key="index">{{ item.name }}</Option>
            </Select>
        </div>
        <div class="d-flex-item ml-xs">
            <Select clearable class="width-all" v-model="value[2]" @on-select="onAreas">
                <Option v-for="(item, index) in areas" :value="item.code" :key="index">{{ item.name }}</Option>
            </Select>
        </div>
        <div class="d-flex-item ml-xs">
            <Select clearable class="width-all" v-model="value[3]" @on-select="onJiedao">
                <Option v-for="(item, index) in jiedao" :value="item.code" :key="index">{{ item.name }}</Option>
            </Select>
        </div>
        <div class="d-flex-item ml-xs">
            <Select clearable class="width-all" v-model="value[4]" @on-select="onCunwei">
                <Option v-for="(item, index) in cunwei" :value="item.code" :key="index">{{ item.name }}</Option>
            </Select>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            data: Array,
            name: Array,
        },
        data() {
            return {
                value: [],
                names: [],

                provs: [], // 省
                citys: [], // 市
                areas: [], // 区/县
                jiedao: [], // 街道
                cunwei: [], // 村委
            }
        },
        async mounted() {
            await setTimeout(async ()=> {
                if (this.data && this.data.length > 0){
                    this.value = this.data;
                    this.names = this.name;
                    await this.getRegion('', 1);
                    await this.getRegion(this.value[0], 2);
                    await this.getRegion(this.value[1], 3);
                    await this.getRegion(this.value[2], 4);
                    await this.getRegion(this.value[3], 5);
                } else {
                    await this.getRegion('', 1);
                }
            }, 100);
        },
        methods: {
            async getRegion(data, kind){
                let res = await this.$api.getHttp('region/parentCode?parentCode=' + data);
                console.log('this.getRegion---------->', res);
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                if (kind === 1){
                    this.provs = res.data.data;
                }
                if (kind === 2){
                    this.citys = res.data.data;
                }
                if (kind === 3){
                    this.areas = res.data.data;
                }
                if (kind === 4){
                    this.jiedao = res.data.data;
                }
                if (kind === 5){
                    this.cunwei = res.data.data;
                }
                this.$forceUpdate();
            },

            async onProvs(data){
                // debugger
                await this.getRegion(data.value, 2);
                this.value[0] = data.value;
                this.names[0] = data.label;
                this.$store.commit('initRegionValue', this.value);
                this.$store.commit('initRegionName', this.names);
            },

            async onCitys(data){
                // debugger
                await this.getRegion(data.value, 3);
                this.value[1] = data.value;
                this.names[1] = data.label;
                this.$store.commit('initRegionValue', this.value);
                this.$store.commit('initRegionName', this.names);
            },

            async onAreas(data){
                // debugger
                await this.getRegion(data.value, 4);
                this.value[2] = data.value;
                this.names[2] = data.label;
                this.$store.commit('initRegionValue', this.value);
                this.$store.commit('initRegionName', this.names);
            },
            async onJiedao(data){
                await this.getRegion(data.value, 5);
                this.value[3] = data.value;
                this.names[3] = data.label;
                this.$store.commit('initRegionValue', this.value);
                this.$store.commit('initRegionName', this.names);
            },
            async onCunwei(data){
                this.value[4] = data.value;
                this.names[4] = data.label;
                this.$store.commit('initRegionValue', this.value);
                this.$store.commit('initRegionName', this.names);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Region.vue